import { useEffect, useState } from 'react'

export function useMyBookingsViewModel({ repository, session }) {
  const [status, setStatus] = useState('idle')
  const [bookings, setBookings] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!session?.user?.id) return
    setStatus('loading')
    repository
      .fetchBookings(session.user.id)
      .then((data) => {
        setBookings(data)
        setStatus('loaded')
      })
      .catch((err) => {
        setError(err.message ?? 'Failed to load bookings')
        setStatus('failed')
      })
  }, [repository, session])

  return { status, bookings, error }
}
